export default __webpack_public_path__ + "static/media/icon_project.6bd410fd.svg";